import React from 'react';
import GameStudio from '../../features/apps/components/GameStudio';

const GameStudioRoute = () => {
  return <GameStudio />;
};

export default GameStudioRoute;
